import FaqBlock from "pages/Homepage/FaqBlock/FaqBlock";
import Hero from "pages/Homepage/Hero/Hero";
import LoginBlock from "pages/Homepage/LoginBlock/LoginBlock";
import Slider from "pages/Homepage/Slider/Slider";
import Usps from "pages/Homepage/Usps/Usps";
import { useAccount } from "context/AccountContext";
import Trans from "features/translation/components/Trans";
import useEntity from "hooks/useEntity";
import Alert from "components/ui/Alert/Alert";
import { useTitle } from "hooks/useTitle";

function Home({ title }) {
  const { entity, isLoading, error } = useEntity('/', 'frontpage');
  const { profile } = useAccount();

  useTitle(title);

  if (!isLoading && !entity) {
    return <Alert message={ error }/>;
  }

  return (
    <>
      <Hero intro={ entity?.field_intro?.value }/>

      <div className={ 'wrapper--fluid wrapper--margin' }>
        <Usps/>
      </div>

      <div className={ 'wrapper--fluid margin-bottom-small text-center' }>
        <h1><Trans text={ 'Kom makkelijk in contact met andere leden' } /></h1>
        <div><Trans text={ 'Houdt u van gezelligheid? Dan bent u op de goede plek!' } /></div>
      </div>

      <div className={ 'wrapper--fluid wrapper--margin swiper-homepage' }>
        <Slider/>
      </div>

      <div className={ 'wrapper--fluid' }>
        <FaqBlock entity={ entity }/>
      </div>

      { !profile &&
      <div className={ 'wrapper--fluid' }>
        <LoginBlock/>
      </div>
      }
    </>
  );
}

export default Home;
